// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 24px 0 24px;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}
.dialog-header mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.dialog-header h3 {
  color: #333;
  font-weight: 600;
  font-size: 1.5rem;
  margin: 0;
}
@media (max-width: 600px) {
  .dialog-header {
    padding: 16px 16px 0 16px;
  }
  .dialog-header mat-icon {
    font-size: 24px;
    width: 24px;
    height: 24px;
  }
  .dialog-header h3 {
    font-size: 1.25rem;
  }
}

.dialog-content {
  min-width: 500px;
  padding: 0 24px 24px 24px;
  max-height: 60vh;
  overflow-y: auto;
}
@media (max-width: 600px) {
  .dialog-content {
    min-width: auto;
    width: 100%;
    padding: 0 16px 16px 16px;
    max-height: 70vh;
  }
}
@media (max-width: 400px) {
  .dialog-content {
    padding: 0 12px 12px 12px;
  }
}

.warning-message {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  margin-bottom: 20px;
}
.warning-message mat-icon {
  flex-shrink: 0;
  margin-top: 2px;
}
.warning-message p {
  margin: 0;
  font-size: 14px;
  color: #856404;
  line-height: 1.5;
}
@media (max-width: 600px) {
  .warning-message {
    padding: 12px;
    margin-bottom: 16px;
  }
  .warning-message p {
    font-size: 13px;
  }
}

.user-info-card {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}
.user-info-card .info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}
.user-info-card .info-row:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}
.user-info-card .info-row .label {
  font-weight: 600;
  color: #666;
  font-size: 14px;
}
.user-info-card .info-row .value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  word-break: break-word;
  text-align: right;
  max-width: 60%;
}
@media (max-width: 600px) {
  .user-info-card {
    padding: 12px;
    margin-bottom: 16px;
  }
  .user-info-card .info-row {
    padding: 6px 0;
  }
  .user-info-card .info-row .label,
  .user-info-card .info-row .value {
    font-size: 13px;
  }
}

.security-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #e3f2fd;
  border-left: 4px solid #2196f3;
  border-radius: 4px;
  margin-top: 20px;
}
.security-notice mat-icon {
  flex-shrink: 0;
  color: #2196f3;
}
.security-notice p {
  margin: 0;
  font-size: 13px;
  color: #0d47a1;
  line-height: 1.4;
}
@media (max-width: 600px) {
  .security-notice {
    padding: 10px 12px;
    margin-top: 16px;
  }
  .security-notice p {
    font-size: 12px;
  }
}

mat-dialog-actions {
  padding: 16px 24px;
  gap: 12px;
}
mat-dialog-actions button mat-icon {
  margin-right: 4px;
}
@media (max-width: 600px) {
  mat-dialog-actions {
    padding: 12px 16px;
    gap: 8px;
  }
  mat-dialog-actions button {
    flex: 1;
    min-width: 100px;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/impersonation-confirm-dialog/impersonation-confirm-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,iBAAA;EACA,WAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ;AAEE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAAJ;AAGE;EAvBF;IAwBI,yBAAA;EAAF;EAEE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAAJ;EAGE;IACE,kBAAA;EADJ;AACF;;AAKA;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;AAIE;EANF;IAOI,eAAA;IACA,WAAA;IACA,yBAAA;IACA,gBAAA;EADF;AACF;AAGE;EAbF;IAcI,yBAAA;EAAF;AACF;;AAGA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAEE;EACE,cAAA;EACA,eAAA;AAAJ;AAGE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAIE;EArBF;IAsBI,aAAA;IACA,mBAAA;EADF;EAGE;IACE,eAAA;EADJ;AACF;;AAKA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAFF;AAIE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AAFJ;AAII;EACE,gCAAA;AAFN;AAKI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAHN;AAMI;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;AAJN;AAQE;EAhCF;IAiCI,aAAA;IACA,mBAAA;EALF;EAOE;IACE,cAAA;EALJ;EAOI;;IAEE,eAAA;EALN;AACF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAPF;AASE;EACE,cAAA;EACA,cAAA;AAPJ;AAUE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AARJ;AAWE;EAtBF;IAuBI,kBAAA;IACA,gBAAA;EARF;EAUE;IACE,eAAA;EARJ;AACF;;AAYA;EACE,kBAAA;EACA,SAAA;AATF;AAYI;EACE,iBAAA;AAVN;AAcE;EAVF;IAWI,kBAAA;IACA,QAAA;EAXF;EAaE;IACE,OAAA;IACA,gBAAA;EAXJ;AACF;AACA,gzLAAgzL","sourcesContent":[".dialog-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 24px 24px 0 24px;\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 10;\n\n  mat-icon {\n    font-size: 28px;\n    width: 28px;\n    height: 28px;\n  }\n\n  h3 {\n    color: #333;\n    font-weight: 600;\n    font-size: 1.5rem;\n    margin: 0;\n  }\n\n  @media (max-width: 600px) {\n    padding: 16px 16px 0 16px;\n\n    mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n\n    h3 {\n      font-size: 1.25rem;\n    }\n  }\n}\n\n.dialog-content {\n  min-width: 500px;\n  padding: 0 24px 24px 24px;\n  max-height: 60vh;\n  overflow-y: auto;\n\n  @media (max-width: 600px) {\n    min-width: auto;\n    width: 100%;\n    padding: 0 16px 16px 16px;\n    max-height: 70vh;\n  }\n\n  @media (max-width: 400px) {\n    padding: 0 12px 12px 12px;\n  }\n}\n\n.warning-message {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: #fff3cd;\n  border-left: 4px solid #ffc107;\n  border-radius: 4px;\n  margin-bottom: 20px;\n\n  mat-icon {\n    flex-shrink: 0;\n    margin-top: 2px;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    color: #856404;\n    line-height: 1.5;\n  }\n\n  @media (max-width: 600px) {\n    padding: 12px;\n    margin-bottom: 16px;\n\n    p {\n      font-size: 13px;\n    }\n  }\n}\n\n.user-info-card {\n  background: #f5f5f5;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n\n  .info-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 0;\n\n    &:not(:last-child) {\n      border-bottom: 1px solid #e0e0e0;\n    }\n\n    .label {\n      font-weight: 600;\n      color: #666;\n      font-size: 14px;\n    }\n\n    .value {\n      font-size: 14px;\n      color: #333;\n      font-weight: 500;\n      word-break: break-word;\n      text-align: right;\n      max-width: 60%;\n    }\n  }\n\n  @media (max-width: 600px) {\n    padding: 12px;\n    margin-bottom: 16px;\n\n    .info-row {\n      padding: 6px 0;\n\n      .label,\n      .value {\n        font-size: 13px;\n      }\n    }\n  }\n}\n\n.security-notice {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #e3f2fd;\n  border-left: 4px solid #2196f3;\n  border-radius: 4px;\n  margin-top: 20px;\n\n  mat-icon {\n    flex-shrink: 0;\n    color: #2196f3;\n  }\n\n  p {\n    margin: 0;\n    font-size: 13px;\n    color: #0d47a1;\n    line-height: 1.4;\n  }\n\n  @media (max-width: 600px) {\n    padding: 10px 12px;\n    margin-top: 16px;\n\n    p {\n      font-size: 12px;\n    }\n  }\n}\n\nmat-dialog-actions {\n  padding: 16px 24px;\n  gap: 12px;\n\n  button {\n    mat-icon {\n      margin-right: 4px;\n    }\n  }\n\n  @media (max-width: 600px) {\n    padding: 12px 16px;\n    gap: 8px;\n\n    button {\n      flex: 1;\n      min-width: 100px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
